import FnrTypography from "FnrTypography";

import { useWithoutValueText } from "UI/FnrUploadButton/stateHooks";

import { useFnrUploadButtonContext } from "../../FnrUploadButton";
import DisplayContainer from "../DisplayContainer";

const WithoutValueDisplay = () => {
  const { compact, typographyProps, onEditClick  } = useFnrUploadButtonContext();
  const withoutValueText = useWithoutValueText();

  return (
    <DisplayContainer
      onClick={onEditClick}
      $canOpenSacramentEditor={Boolean(onEditClick)}
      $compact={compact}
    >
      <FnrTypography
        noWrap={compact}
        fontSize={compact ? "xs" : "md"}
        color="textSecondary"
        {...typographyProps}
      >
        {withoutValueText}
      </FnrTypography>
    </DisplayContainer>
  );
};

export default WithoutValueDisplay;